import styled from 'styled-components';
import { BdsPaper } from 'blip-ds/dist/blip-ds-react';

export const BannerContainer = styled(BdsPaper)`
  background-color: rgb(128, 227, 235);

  bds-illustration {
    width: 56px;
    height: 56px;
  }
`;

export const DownloadLink = styled.a`
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
  
  &:focus {
    text-decoration: underline;
    outline: 2px solid var(--color-primary);
    outline-offset: 2px;
  }

  &:visited {
    color: inherit;
    text-decoration: none;
  }
  
  &:active {
    color: inherit;
    text-decoration: none;
  }
`;
